export type NewsArticle = {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  channel: string;
  channelSlug: string;
  summary: string;
  content: string[];
  cover: string;
  gallery: string[];
  author: string;
  publishTime: string;
  region: string;
  tags: string[];
  views: number;
  shares: number;
  featured: boolean;
  editorPick: boolean;
};

export type Category = {
  name: string;
  slug: string;
  icon: string;
  desc: string;
};

export type Channel = {
  name: string;
  slug: string;
  icon: string;
  desc: string;
  banners: number;
};

export type Topic = {
  title: string;
  desc: string;
  tag: string;
  cover: string;
};

export const categories: Category[] = [
  {
    name: "娱乐新闻",
    slug: "entertainment-news",
    icon: "ri-newspaper-line",
    desc: "聚焦娱乐圈每日热点大事，第一时间报道官方动态、行业风向与热门话题。",
  },
  {
    name: "明星八卦",
    slug: "star-gossip",
    icon: "ri-chat-smile-2-line",
    desc: "网罗明星情感、生活与日常趣事，捕捉娱乐圈最受关注的八卦爆料。",
  },
  {
    name: "影视音乐",
    slug: "film-music",
    icon: "ri-movie-2-line",
    desc: "覆盖影视剧集、院线电影与音乐作品，带来票房、口碑与现场的鲜活报道。",
  },
  {
    name: "综艺动态",
    slug: "variety-show",
    icon: "ri-live-line",
    desc: "直击各大综艺节目录制现场，盘点嘉宾阵容、赛制亮点与收视话题。",
  },
  {
    name: "独家爆料",
    slug: "exclusive",
    icon: "ri-flashlight-line",
    desc: "吃瓜爆料网独家渠道整理的重磅爆料，带你抢先一步了解圈内大事。",
  },
];

export const channels: Channel[] = [
  {
    name: "热剧追踪",
    slug: "hot-drama",
    icon: "ri-tv-2-line",
    desc: "聚合近期热播剧集的开播、口碑、名场面与幕后花絮，追剧不错过任何高能。",
    banners: 3,
  },
  {
    name: "明星情感",
    slug: "star-romance",
    icon: "ri-heart-3-line",
    desc: "恋爱、婚讯、分合传闻统统收录，客观梳理明星情感世界的每一次波动。",
    banners: 3,
  },
  {
    name: "音乐现场",
    slug: "music-live",
    icon: "ri-music-2-line",
    desc: "演唱会、音乐节与新歌发行的集合频道，感受现场与音符的每一次共振。",
    banners: 3,
  },
  {
    name: "综艺前线",
    slug: "variety-front",
    icon: "ri-mic-line",
    desc: "聚焦热门综艺的最新赛况与嘉宾表现，第一时间送上节目看点解读。",
    banners: 3,
  },
  {
    name: "年度盛典",
    slug: "award-season",
    icon: "ri-award-line",
    desc: "颁奖礼、红毯与年度盘点专题，回顾这一年的高光时刻与热议瞬间。",
    banners: 3,
  },
];

export const regions = ["全部", "内地", "港台", "日韩", "欧美"];

export const timeRanges = ["全部", "今日", "近三天", "近一周", "近一月"];

export const topics: Topic[] = [
  {
    title: "年度娱乐大盘点",
    desc: "带你回顾这一年娱乐圈最具话题度的事件、作品与人气面孔。",
    tag: "年度盘点",
    cover:
      "https://readdy.ai/api/search-image?query=glamorous%20entertainment%20awards%20stage%20with%20golden%20spotlights%20and%20red%20carpet%20confetti%2C%20stylized%20editorial%20graphic%20illustration%2C%20warm%20orange%20and%20yellow%20tones%2C%20festive%20atmosphere&width=800&height=520&seq=topic-year-2026&orientation=landscape",
  },
  {
    title: "热剧幕后纪实",
    desc: "走进爆款剧集的拍摄现场，听主创讲述角色与故事背后的真实细节。",
    tag: "幕后纪实",
    cover:
      "https://readdy.ai/api/search-image?query=film%20set%20behind%20the%20scenes%20with%20camera%20rig%20and%20spotlights%2C%20stylized%20editorial%20graphic%20illustration%2C%20warm%20orange%20and%20amber%20tones%2C%20cinematic%20mood&width=800&height=520&seq=topic-drama-2026&orientation=landscape",
  },
  {
    title: "恋情传闻全梳理",
    desc: "一条时间线看懂近期明星恋情相关的传闻脉络与各方回应。",
    tag: "情感时间线",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20romantic%20illustration%20of%20two%20silhouettes%20under%20warm%20city%20lights%20and%20hearts%2C%20stylized%20editorial%20graphic%2C%20coral%20and%20gold%20tones%2C%20dreamy%20atmosphere&width=800&height=520&seq=topic-romance-2026&orientation=landscape",
  },
];

export const newsList: NewsArticle[] = [
  {
    id: "1001",
    title: "顶流男星新片正式开机 神秘阵容首度曝光引发全网热议",
    category: "独家爆料",
    categorySlug: "exclusive",
    channel: "热剧追踪",
    channelSlug: "hot-drama",
    summary:
      "历经数月筹备，备受期待的年度大制作今日正式开机，主创阵容与剧情走向首度曝光，吃瓜爆料网第一时间带来独家解读。",
    content: [
      "今日上午，备受关注的新片在影视基地低调开机。吃瓜爆料网从多个渠道独家确认，该片集结了近年来口碑与流量兼具的实力阵容，导演曾执导多部口碑佳作。",
      "从现场布置来看，剧组在美术与服化道上投入颇多，还原了一个充满年代感的城市街景。有工作人员透露，为呈现真实质感，主要演员提前一个月进组进行形体与台词训练。",
      "关于剧情，片方目前仍保持神秘，仅以一句“关于选择与成长的故事”作为概括。不过多位业内人士向吃瓜爆料网分析，该片或将在题材上做出突破性的尝试。",
      "业内普遍认为，这部作品的成色，很可能成为明年影视市场的重要风向标。吃瓜爆料网将持续跟进影片的拍摄进度与后续动态。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=film%20crew%20and%20camera%20equipment%20on%20a%20moody%20movie%20set%20at%20dusk%2C%20stylized%20editorial%20news%20illustration%2C%20orange%20and%20amber%20tones%2C%20cinematic%20composition&width=800&height=450&seq=news-cover-1001&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=close%20up%20of%20vintage%20film%20camera%20and%20clapperboard%20under%20warm%20studio%20lights%2C%20stylized%20editorial%20graphic%20illustration%2C%20amber%20and%20coral%20tones&width=900&height=520&seq=news-gallery-1001a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=empty%20retro%20city%20street%20movie%20set%20with%20warm%20evening%20light%20and%20vintage%20props%2C%20stylized%20editorial%20graphic%20illustration%2C%20amber%20and%20gold%20tones&width=900&height=520&seq=news-gallery-1001b&orientation=landscape",
    ],
    author: "吃瓜爆料网编辑部",
    publishTime: "2026-10-14T09:20:00",
    region: "内地",
    tags: ["新片开机", "顶流男星", "年度大制作"],
    views: 428600,
    shares: 18600,
    featured: true,
    editorPick: true,
  },
  {
    id: "1002",
    title: "人气女歌手全新巡演官宣 首站门票十秒售罄刷新纪录",
    category: "影视音乐",
    categorySlug: "film-music",
    channel: "音乐现场",
    channelSlug: "music-live",
    summary:
      "时隔两年，人气女歌手携全新专辑与巡演回归，首站开票瞬间售罄，观众对舞台设计的期待值拉满。",
    content: [
      "昨日中午，人气女歌手在社交平台正式官宣全新一轮巡回演唱会。消息发布后不到一小时，相关话题便冲上热搜榜单前列。",
      "据吃瓜爆料网了解，本次巡演将采用全新的四面台设计，配合可升降的舞台机械与环绕式灯光，营造沉浸式的观演体验。制作团队曾参与多个国际级演出项目。",
      "首站门票于今日上午十点正式开售，十秒内即告售罄，平台一度出现访问高峰。主办方表示，将根据观众反馈评估加场的可能性。",
      "乐评人向吃瓜爆料网表示，这位歌手近年来在现场表现力上持续突破，本轮巡演有望成为年度最受期待的演出之一。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=grand%20concert%20stage%20with%20spotlights%20and%20crowd%20silhouettes%2C%20stylized%20editorial%20news%20illustration%2C%20vibrant%20orange%20and%20yellow%20stage%20lighting%2C%20energetic%20atmosphere&width=800&height=450&seq=news-cover-1002&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=concert%20microphone%20on%20stage%20with%20warm%20spotlight%20and%20glowing%20bokeh%2C%20stylized%20editorial%20graphic%20illustration%2C%20amber%20and%20coral%20tones&width=900&height=520&seq=news-gallery-1002a&orientation=landscape",
    ],
    author: "文/音乐组 林小满",
    publishTime: "2026-10-14T08:05:00",
    region: "内地",
    tags: ["巡回演唱会", "新专辑", "门票售罄"],
    views: 356200,
    shares: 15200,
    featured: true,
    editorPick: true,
  },
  {
    id: "1003",
    title: "王牌综艺迎来收官之夜 全员回归引爆收视与话题双高峰",
    category: "综艺动态",
    categorySlug: "variety-show",
    channel: "综艺前线",
    channelSlug: "variety-front",
    summary:
      "陪伴观众一整季的王牌综艺迎来收官，老成员惊喜回归，多个名场面接连上演，节目热度再创新高。",
    content: [
      "本周五晚，备受喜爱的王牌综艺迎来本季收官之夜。节目组特意邀请多位往季成员回归，现场笑声与泪水交织。",
      "据吃瓜爆料网观察，收官期节目在多个社交平台的话题阅读量迅速攀升，多个片段登上热榜，观众纷纷留言表达不舍。",
      "节目导演在接受采访时表示，本季在赛制上做了大量调整，力求让嘉宾的真实状态被更多呈现，这也是节目口碑回暖的重要原因。",
      "业内人士分析，该综艺已经形成稳定的受众基础，后续或将推出特别企划，延续这一IP的生命力。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20tv%20studio%20stage%20with%20neon%20lights%20and%20audience%20seats%2C%20stylized%20editorial%20news%20illustration%2C%20playful%20orange%20and%20yellow%20tones%2C%20festive%20mood&width=800&height=450&seq=news-cover-1003&orientation=landscape",
    gallery: [],
    author: "文/综艺组 陈可",
    publishTime: "2026-10-13T22:40:00",
    region: "内地",
    tags: ["综艺收官", "全员回归", "收视话题"],
    views: 298400,
    shares: 12400,
    featured: true,
    editorPick: false,
  },
  {
    id: "1004",
    title: "实力男演员被拍到深夜同框 双方工作室回应引发新一轮猜测",
    category: "明星八卦",
    categorySlug: "star-gossip",
    channel: "明星情感",
    channelSlug: "star-romance",
    summary:
      "有网友拍到两位演员深夜同框的画面，相关话题迅速发酵，双方工作室的回应耐人寻味，引发全网讨论。",
    content: [
      "近日，有网友在社交平台晒出两段模糊视频，称在城区某餐厅外偶遇两位演员深夜同行。画面曝光后，相关话题迅速登上热搜。",
      "截至吃瓜爆料网发稿前，两位当事人尚未就传闻作出正面说明，其工作室仅发布了措辞谨慎的统一回应，强调“以作品为主”。",
      "有粉丝在评论区表示理解，也有观众呼吁理性看待，不要过度解读艺人的私人行程。",
      "吃瓜爆料网提醒，娱乐新闻应以事实为依据，对于尚未证实的传闻，建议读者保持理性，关注艺人的公开作品与动态。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=city%20night%20street%20with%20warm%20streetlights%20and%20blurred%20figures%20walking%2C%20stylized%20editorial%20news%20illustration%2C%20coral%20and%20amber%20tones%2C%20mysterious%20atmosphere&width=800&height=450&seq=news-cover-1004&orientation=landscape",
    gallery: [],
    author: "文/八卦组 苏晴",
    publishTime: "2026-10-13T20:15:00",
    region: "内地",
    tags: ["明星恋情", "同框", "工作室回应"],
    views: 512800,
    shares: 26400,
    featured: true,
    editorPick: true,
  },
  {
    id: "1005",
    title: "影视盛典红毯群星闪耀 高定礼服与新生代面孔成全场焦点",
    category: "娱乐新闻",
    categorySlug: "entertainment-news",
    channel: "年度盛典",
    channelSlug: "award-season",
    summary:
      "年度影视盛典红毯盛装举行，多位实力派与新生代艺人悉数亮相，高定造型与造型细节成为热议话题。",
    content: [
      "昨晚，年度影视盛典红毯仪式在城市大剧院举行，红毯现场星光熠熠，聚集了大批影视从业者与媒体记者。",
      "吃瓜爆料网注意到，今年的红毯造型整体偏向简约高级，多位艺人选择了高定礼服与低调配饰，突出个人气质。",
      "除了资深演员，一批新生代面孔的表现同样亮眼，他们在采访中表达了对前辈的敬意与对未来的期待。",
      "盛典共颁发多个奖项，涵盖表演、导演、制作等多个领域。完整获奖名单可继续关注吃瓜爆料网的后续报道。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20event%20with%20photographers%20and%20golden%20lights%2C%20stylized%20editorial%20news%20illustration%2C%20warm%20orange%20and%20gold%20tones%2C%20glamorous%20mood&width=800&height=450&seq=news-cover-1005&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=red%20carpet%20with%20spotlights%20and%20elegant%20golden%20decoration%2C%20stylized%20editorial%20graphic%20illustration%2C%20amber%20and%20coral%20tones&width=900&height=520&seq=news-gallery-1005a&orientation=landscape",
    ],
    author: "文/时尚组 白露",
    publishTime: "2026-10-13T18:00:00",
    region: "内地",
    tags: ["影视盛典", "红毯造型", "颁奖礼"],
    views: 274300,
    shares: 9800,
    featured: true,
    editorPick: false,
  },
  {
    id: "1006",
    title: "人气男演员宣布转型幕后 首部监制作品已进入筹备阶段",
    category: "娱乐新闻",
    categorySlug: "entertainment-news",
    channel: "热剧追踪",
    channelSlug: "hot-drama",
    summary:
      "在演员身份之外，这位人气男演员将首次担任监制，其团队透露项目已进入筹备阶段，题材颇具新意。",
    content: [
      "据吃瓜爆料网独家了解，人气男演员将在新项目中首次担任监制，从演员身份向幕后延伸成为其职业规划的重要一步。",
      "相关人士透露，该项目目前处于剧本打磨与团队组建阶段，题材与这位演员过往作品风格有所区分，更注重现实表达。",
      "业内人士评价，演员转型幕后近年来并不少见，但能否在内容层面形成个人风格，仍需作品来检验。",
      "对于外界的关注，其团队表示会在合适的时间公布更多细节，也希望大家给予创作者足够的空间。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=script%20notebook%20and%20pen%20on%20a%20wooden%20desk%20with%20warm%20lamp%20light%2C%20stylized%20editorial%20news%20illustration%2C%20amber%20and%20brown%20tones%2C%20focused%20mood&width=800&height=450&seq=news-cover-1006&orientation=landscape",
    gallery: [],
    author: "文/影视组 周游",
    publishTime: "2026-10-13T15:30:00",
    region: "内地",
    tags: ["转型监制", "幕后", "筹备"],
    views: 189600,
    shares: 6400,
    featured: false,
    editorPick: false,
  },
  {
    id: "1007",
    title: "人气女团携新曲回归舞台 编舞难度升级获赞舞台王者",
    category: "影视音乐",
    categorySlug: "film-music",
    channel: "音乐现场",
    channelSlug: "music-live",
    summary:
      "人气女团时隔数月携全新单曲回归，全新的高难度编舞与视觉概念让回归舞台收获一片好评。",
    content: [
      "本月初，人气女团正式发布全新单曲并公开舞台。回归舞台一经上线，便凭借整齐的群舞与强烈的视觉风格引发讨论。",
      "吃瓜爆料网了解到，本次编舞由国际团队操刀，整体难度较以往明显提升，成员们在回归前进行了长时间集训。",
      "音乐方面，新曲融合了流行与电子元素，副歌部分的记忆点设计颇为用心，被认为具备较强的传播潜力。",
      "随着回归活动的展开，女团还将陆续参加音乐节目与线下活动，吃瓜爆料网将持续带来相关报道。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=group%20of%20dancers%20on%20a%20glowing%20stage%20with%20dynamic%20lights%2C%20stylized%20editorial%20news%20illustration%2C%20vibrant%20orange%20and%20pink%20tones%2C%20energetic%20mood&width=800&height=450&seq=news-cover-1007&orientation=landscape",
    gallery: [],
    author: "文/音乐组 林小满",
    publishTime: "2026-10-12T19:10:00",
    region: "日韩",
    tags: ["女团回归", "新曲", "编舞"],
    views: 233500,
    shares: 8700,
    featured: false,
    editorPick: true,
  },
  {
    id: "1008",
    title: "明星夫妻档综艺首度合体 日常相处模式被赞真实又甜蜜",
    category: "综艺动态",
    categorySlug: "variety-show",
    channel: "明星情感",
    channelSlug: "star-romance",
    summary:
      "一对结婚多年的明星夫妻首度同框参加综艺，节目中自然真实的相处细节圈粉无数，被网友称为“婚姻日常教科书”。",
    content: [
      "最新一期综艺中，一对结婚多年的明星夫妻首度合体出演，节目记录了他们寻常又温馨的相处片段。",
      "没有刻意的表演，两人的互动自然流畅，一句玩笑、一个眼神都被观众捕捉并展开讨论。",
      "吃瓜爆料网注意到，该期节目播出后，相关片段在短视频平台获得大量转发，不少观众留言称“看到了婚姻的样子”。",
      "节目组表示，邀请夫妻档的初衷是呈现真实生活，而非制造戏剧冲突，后续还会有更多不同家庭的日常被呈现。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20living%20room%20with%20soft%20lamps%20and%20two%20coffee%20cups%2C%20stylized%20editorial%20news%20illustration%2C%20coral%20and%20amber%20tones%2C%20tender%20mood&width=800&height=450&seq=news-cover-1008&orientation=landscape",
    gallery: [],
    author: "文/综艺组 陈可",
    publishTime: "2026-10-12T14:20:00",
    region: "内地",
    tags: ["明星夫妻", "综艺", "日常"],
    views: 176900,
    shares: 7200,
    featured: false,
    editorPick: false,
  },
  {
    id: "1009",
    title: "年度剧集收视榜单出炉 现实题材作品占据半壁江山",
    category: "影视音乐",
    categorySlug: "film-music",
    channel: "热剧追踪",
    channelSlug: "hot-drama",
    summary:
      "最新公布的年度剧集收视榜单显示，现实题材作品表现突出，多部作品凭借口碑发酵实现逆势上扬。",
    content: [
      "近日，一份年度剧集收视榜单引发行业关注。数据显示，现实题材作品在收视与讨论度上均有亮眼表现。",
      "吃瓜爆料网梳理发现，榜单前列的作品大多在剧本与表演上下功夫，靠口碑发酵而非单纯依赖流量。",
      "有从业者分析，观众对内容质量的要求正在提升，扎实的现实表达更容易获得共鸣。",
      "榜单同时显示，短剧集的接受度持续走高，紧凑的叙事节奏成为不少作品的选择。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20dvd%20cases%20and%20a%20remote%20control%20on%20a%20warm%20table%2C%20stylized%20editorial%20news%20illustration%2C%20amber%20and%20orange%20tones%2C%20analytical%20mood&width=800&height=450&seq=news-cover-1009&orientation=landscape",
    gallery: [],
    author: "文/影视组 周游",
    publishTime: "2026-10-12T11:00:00",
    region: "内地",
    tags: ["收视榜单", "现实题材", "剧集"],
    views: 142700,
    shares: 5100,
    featured: false,
    editorPick: false,
  },
  {
    id: "1010",
    title: "大型户外音乐节落幕 三天吸引数万乐迷留下无数名场面",
    category: "影视音乐",
    categorySlug: "film-music",
    channel: "音乐现场",
    channelSlug: "music-live",
    summary:
      "为期三天的大型户外音乐节圆满落幕，数十组音乐人轮番登台，现场氛围与舞台呈现获乐迷一致好评。",
    content: [
      "上周末，大型户外音乐节在城市郊区的草坪营地举行，三天共吸引数万名乐迷到场参与。",
      "从午后到深夜，多组音乐人轮番登台，涵盖了摇滚、流行、民谣等多种风格，满足了不同乐迷的口味。",
      "吃瓜爆料网在现场看到，主办方在舞台设计、动线规划与后勤保障上做了充分准备，整体体验较为顺畅。",
      "多位乐迷表示，音乐节的魅力在于现场的共鸣与自由氛围，希望这样的活动能够持续办下去。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20with%20evening%20sky%20and%20stage%20lights%2C%20stylized%20editorial%20news%20illustration%2C%20orange%20and%20gold%20tones%2C%20festive%20mood&width=800&height=450&seq=news-cover-1010&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=sunset%20over%20an%20outdoor%20festival%20stage%20with%20crowd%20silhouettes%2C%20stylized%20editorial%20graphic%20illustration%2C%20amber%20and%20coral%20tones&width=900&height=520&seq=news-gallery-1010a&orientation=landscape",
    ],
    author: "文/音乐组 林小满",
    publishTime: "2026-10-11T23:30:00",
    region: "内地",
    tags: ["音乐节", "现场", "乐迷"],
    views: 165400,
    shares: 6300,
    featured: false,
    editorPick: false,
  },
  {
    id: "1011",
    title: "众多明星参与公益行动 用影响力为乡村教育点亮一盏灯",
    category: "娱乐新闻",
    categorySlug: "entertainment-news",
    channel: "年度盛典",
    channelSlug: "award-season",
    summary:
      "多位艺人近日陆续参与公益项目，通过捐建图书室、开设线上课堂等形式，为乡村教育贡献力量。",
    content: [
      "连日来，多位艺人先后参与到乡村教育相关的公益行动中，用实际行动传递温暖。",
      "据吃瓜爆料网了解，本次公益项目将陆续在多地捐建图书室，并邀请专业人士开设线上兴趣课堂。",
      "参与的艺人表示，公益不是一时的热情，而是长期坚持的陪伴，希望能真正给孩子们带来改变。",
      "项目负责人介绍，后续还会公开透明的进展公示，让每一份善意都能被看见与追踪。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20books%20and%20school%20supplies%20on%20a%20wooden%20table%20with%20warm%20sunlight%2C%20stylized%20editorial%20news%20illustration%2C%20amber%20and%20orange%20tones%2C%20hopeful%20mood&width=800&height=450&seq=news-cover-1011&orientation=landscape",
    gallery: [],
    author: "文/公益组 顾念",
    publishTime: "2026-10-11T16:45:00",
    region: "内地",
    tags: ["明星公益", "乡村教育", "正能量"],
    views: 98700,
    shares: 8900,
    featured: false,
    editorPick: false,
  },
  {
    id: "1012",
    title: "知名导演新作定档年末 预告片细节满满被观众逐帧解读",
    category: "影视音乐",
    categorySlug: "film-music",
    channel: "热剧追踪",
    channelSlug: "hot-drama",
    summary:
      "知名导演新作正式宣布定档年末，首支预告片信息量十足，观众纷纷逐帧分析，期待值持续攀升。",
    content: [
      "昨日，知名导演的新作正式宣布定档年末，同步释出首支预告片，短短两分钟便掀起讨论热潮。",
      "预告片中，导演标志性的镜头语言与色调风格一览无余，多个细节被观众反复解读，衍生出诸多猜测。",
      "吃瓜爆料网了解到，该片在后期制作上投入了大量时间，力求在视听呈现上达到理想效果。",
      "业内人士认为，年底档期竞争激烈，但凭借导演以往的口碑积累，这部作品仍是备受期待的一部。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20theater%20with%20dim%20red%20seats%20and%20glowing%20screen%2C%20stylized%20editorial%20news%20illustration%2C%20amber%20and%20coral%20tones%2C%20cinematic%20mood&width=800&height=450&seq=news-cover-1012&orientation=landscape",
    gallery: [],
    author: "文/影视组 周游",
    publishTime: "2026-10-11T10:20:00",
    region: "内地",
    tags: ["新片定档", "预告片", "导演新作"],
    views: 156300,
    shares: 5800,
    featured: false,
    editorPick: true,
  },
  {
    id: "1013",
    title: "选秀节目新一季启动海选 素人选手凭实力片段意外走红",
    category: "综艺动态",
    categorySlug: "variety-show",
    channel: "综艺前线",
    channelSlug: "variety-front",
    summary:
      "选秀节目新一季启动海选，一位素人选手的表演片段在网络上意外走红，引发对“实力与机会”的讨论。",
    content: [
      "选秀节目新一季近日启动海选，报名通道开启后便收到了大量报名视频。",
      "其中，一位素人选手的表演片段在网络上被广泛转发，干净细腻的呈现收获了不少好评。",
      "有网友感慨，舞台之外仍有大量有实力的人等待被看见，这也是选秀节目的意义之一。",
      "节目组表示，本季将更加注重选手的成长过程，而不是单纯追求话题与流量。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=audition%20stage%20with%20single%20spotlight%20and%20empty%20microphone%20stand%2C%20stylized%20editorial%20news%20illustration%2C%20amber%20and%20orange%20tones%2C%20dramatic%20mood&width=800&height=450&seq=news-cover-1013&orientation=landscape",
    gallery: [],
    author: "文/综艺组 陈可",
    publishTime: "2026-10-10T20:00:00",
    region: "内地",
    tags: ["选秀", "海选", "素人选手"],
    views: 134200,
    shares: 4900,
    featured: false,
    editorPick: false,
  },
  {
    id: "1014",
    title: "女演员机场造型被热议 简约基础款穿出高级感引穿搭讨论",
    category: "明星八卦",
    categorySlug: "star-gossip",
    channel: "年度盛典",
    channelSlug: "award-season",
    summary:
      "一位女演员的机场造型被路人拍到后迅速走红，简约基础款搭配被网友称为“可复制的高级感”。",
    content: [
      "近日，一位女演员的机场造型被路人拍摄并在社交平台传播，简约的搭配引发大量穿搭讨论。",
      "与常见的繁复造型不同，此次选择以基础款为主，配饰克制，整体干净利落。",
      "吃瓜爆料网注意到，不少时尚博主对其单品进行了分析，认为“高级感”更多来自版型与色彩的协调。",
      "有网友表示，这样的造型更具参考价值，日常也容易借鉴。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20fashion%20flatlay%20with%20neutral%20toned%20clothes%20and%20accessories%2C%20stylized%20editorial%20news%20illustration%2C%20warm%20beige%20and%20coral%20tones%2C%20elegant%20mood&width=800&height=450&seq=news-cover-1014&orientation=landscape",
    gallery: [],
    author: "文/时尚组 白露",
    publishTime: "2026-10-10T15:10:00",
    region: "内地",
    tags: ["机场造型", "穿搭", "高级感"],
    views: 118600,
    shares: 4300,
    featured: false,
    editorPick: false,
  },
  {
    id: "1015",
    title: "综艺嘉宾互换身份上演名场面 反差表现让观众笑到停不下来",
    category: "综艺动态",
    categorySlug: "variety-show",
    channel: "综艺前线",
    channelSlug: "variety-front",
    summary:
      "本期综艺设置身份互换环节，嘉宾们体验彼此的工作与生活，反差表现制造出大量名场面。",
    content: [
      "本期综艺推出了“身份互换”主题，让嘉宾体验彼此日常的工作与生活，节目效果拉满。",
      "在互换过程中，原本擅长运动的嘉宾需要完成细致的料理任务，而安静的嘉宾则要挑战高强度任务，反差感十足。",
      "吃瓜爆料网看到，节目在制造笑点的同时，也让观众体会到每一份职业背后的不易。",
      "节目播出后，相关片段在短视频平台获得大量转发，成为本季话题度较高的一期。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20variety%20show%20props%20and%20game%20scoreboard%20on%20a%20studio%20set%2C%20stylized%20editorial%20news%20illustration%2C%20playful%20orange%20and%20yellow%20tones&width=800&height=450&seq=news-cover-1015&orientation=landscape",
    gallery: [],
    author: "文/综艺组 陈可",
    publishTime: "2026-10-10T12:30:00",
    region: "内地",
    tags: ["综艺名场面", "身份互换", "反差"],
    views: 109300,
    shares: 4600,
    featured: false,
    editorPick: false,
  },
  {
    id: "1016",
    title: "国庆档电影票房新鲜出炉 类型多样满足不同观影口味",
    category: "影视音乐",
    categorySlug: "film-music",
    channel: "热剧追踪",
    channelSlug: "hot-drama",
    summary:
      "国庆档电影票房数据出炉，今年片单类型丰富，覆盖喜剧、动作、动画等多种题材，满足不同观众需求。",
    content: [
      "随着假期的结束，国庆档电影票房数据正式公布。今年档期影片类型分布较为均衡。",
      "吃瓜爆料网梳理发现，多部作品在口碑与票房之间取得平衡，观众选择更加理性。",
      "有影院经理表示，观众的观影习惯正在变化，优质内容与舒适体验成为持续走进影院的关键。",
      "业内预计，随着年末档期的临近，电影市场热度有望继续保持。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20movie%20tickets%20and%20popcorn%20in%20warm%20cinema%20lighting%2C%20stylized%20editorial%20news%20illustration%2C%20amber%20and%20orange%20tones%2C%20cozy%20mood&width=800&height=450&seq=news-cover-1016&orientation=landscape",
    gallery: [],
    author: "文/影视组 周游",
    publishTime: "2026-10-09T18:20:00",
    region: "内地",
    tags: ["票房", "国庆档", "电影市场"],
    views: 127800,
    shares: 5000,
    featured: false,
    editorPick: false,
  },
  {
    id: "1017",
    title: "新生代偶像接下国际品牌代言 市场表现与商业价值被看好",
    category: "娱乐新闻",
    categorySlug: "entertainment-news",
    channel: "年度盛典",
    channelSlug: "award-season",
    summary:
      "一位新生代偶像正式成为国际品牌代言人，其稳定的市场表现与正面形象被品牌方看好。",
    content: [
      "近日，一位新生代偶像正式官宣成为某国际品牌的代言人，相关话题迅速引发关注。",
      "品牌方表示，选择合作对象时更看重其长期形象与专业态度，而不仅是短期热度。",
      "吃瓜爆料网分析，近年来新生代艺人的商业价值持续上升，但可持续性取决于作品与口碑的积累。",
      "对于未来规划，该艺人团队透露，将继续深耕音乐与舞台，稳步拓展更多可能性。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=modern%20fashion%20brand%20campaign%20studio%20with%20spotlights%20and%20podium%2C%20stylized%20editorial%20news%20illustration%2C%20warm%20orange%20and%20gold%20tones&width=800&height=450&seq=news-cover-1017&orientation=landscape",
    gallery: [],
    author: "文/时尚组 白露",
    publishTime: "2026-10-09T11:40:00",
    region: "日韩",
    tags: ["品牌代言", "新生代偶像", "商业价值"],
    views: 112400,
    shares: 3900,
    featured: false,
    editorPick: false,
  },
  {
    id: "1018",
    title: "年度娱乐圈大盘点揭晓 十大话题事件串起一整年的记忆",
    category: "独家爆料",
    categorySlug: "exclusive",
    channel: "年度盛典",
    channelSlug: "award-season",
    summary:
      "吃瓜爆料网年度盘点正式出炉，从作品到话题，十大事件串联起这一年娱乐圈的集体记忆。",
    content: [
      "岁末将至，吃瓜爆料网特别策划年度娱乐圈大盘点，梳理过去一年最具影响力的事件与作品。",
      "从现象级剧集到刷屏舞台，从暖心公益到热议话题，这份盘点试图还原一个真实的娱乐年度。",
      "编辑部表示，盘点不仅回顾高光，也记录了行业的调整与变化，希望为读者提供更完整的观察视角。",
      "完整盘点内容将持续更新，欢迎读者在评论区分享你心中的年度瞬间。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=festive%20year%20in%20review%20graphic%20with%20golden%20stars%20and%20confetti%20over%20warm%20background%2C%20stylized%20editorial%20news%20illustration%2C%20orange%20and%20gold%20tones&width=800&height=450&seq=news-cover-1018&orientation=landscape",
    gallery: [],
    author: "吃瓜爆料网编辑部",
    publishTime: "2026-10-08T09:00:00",
    region: "内地",
    tags: ["年度盘点", "十大事件", "专题策划"],
    views: 203500,
    shares: 11200,
    featured: false,
    editorPick: true,
  },
];